import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  createCampaignThunk,
  createTestCallThunk,
  deleteCampaignThunk,
  getCampaignByIdThunk,
  getCampaignReportThunk,
  getCampaignsThunk,
  getListAudiencesThunk,
  updateCampaignThunk,
  uploadFileThunk,
} from "../actions/campaign.action";
import { getCompanyInfoThunk } from "../actions/company.action";

export interface CampaignState {
  campaigns: {
    campaigns: any[];
    pagination: {
      totalItems: number;
      totalPages: number;
    };
  };
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: CampaignState = {
  campaigns: {
    campaigns: [],
    pagination: {
      totalItems: 0,
      totalPages: 0,
    },
  },
  loading: false,
  error: null,
};

// Dashboard slice
const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFileThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadFileThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadFileThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(createCampaignThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCampaignThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createCampaignThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getCampaignsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCampaignsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.campaigns = action.payload.data;
      })
      .addCase(getCampaignsThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getCampaignByIdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCampaignByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getCampaignByIdThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(updateCampaignThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCampaignThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCampaignThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getCampaignReportThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCampaignReportThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getCampaignReportThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getCompanyInfoThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyInfoThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getCompanyInfoThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(createTestCallThunk.pending, (state) => {})
      .addCase(createTestCallThunk.fulfilled, (state, action) => {})
      .addCase(createTestCallThunk.rejected, (state, action) => {
        state.error = action.payload as string;
      });
    builder
      .addCase(deleteCampaignThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCampaignThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteCampaignThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getListAudiencesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getListAudiencesThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getListAudiencesThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { clearError } = campaignSlice.actions;
export default campaignSlice.reducer;
